import { gql } from '@apollo/client';

export default gql`
  mutation CreateLeadList($input: CreateLeadListInput!) {
    createLeadList(input: $input) {
      id
      estimatedTotalRows
      name
      originalFilename
      columnMapping
      listType
      userName
      company {
        name
      }
      campaign {
        shortId
        name
      }
    }
  }
`;
